/* Banunus waitlist core (Oct 2026)
   Shared by sections/ban-waitlist.liquid, ban-popup.liquid and ban-newsletter.liquid.
   - Captures ?ref=<code> into localStorage (30 days)
   - Derives a 6-character personal code from the email, client-side, at submit time
   - Appends code:<own> and ref:<incoming> to the hidden contact[tags] field
   - Builds / copies the personal share link on the waitlist page
   Loaded with <script defer>; the guard below makes repeated includes a no-op. */
(function (w, d) {
  if (w.BanWL) return;
  var ALPHA = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', DAY = 864e5;

  function get(k, maxAge) {
    try {
      var o = JSON.parse(w.localStorage.getItem(k) || 'null');
      if (!o || typeof o !== 'object') return null;
      if (maxAge && (Date.now() - o.t) > maxAge) return null;
      return o.v;
    } catch (e) { return null; }
  }
  function set(k, v) { try { w.localStorage.setItem(k, JSON.stringify({ v: v, t: Date.now() })); } catch (e) {} }
  function del(k) { try { w.localStorage.removeItem(k); } catch (e) {} }
  function clean(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6); }

  /* FNV-1a 32-bit over the lower-cased email, rendered as 6 chars of a 32-letter alphabet
     (no 0/O/1/I, so codes survive being read aloud or typed). Deterministic: the same email
     always gives the same code, so the owner can recompute it from a customer record. */
  function code(email) {
    var s = String(email || '').trim().toLowerCase();
    if (!s) return '';
    var h = 0x811c9dc5;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
    var out = '';
    for (var k = 0; k < 6; k++) { out += ALPHA[h & 31]; h = h >>> 5; }
    return out;
  }

  var params = new URLSearchParams(w.location.search);
  var incoming = clean(params.get('ref'));
  if (incoming) set('ban_ref', incoming);
  function ref() { return incoming || get('ban_ref', 30 * DAY) || ''; }

  function attach(form) {
    if (!form || form.__banwl) return;
    form.__banwl = true;
    form.addEventListener('submit', function () {
      var em = form.querySelector('input[type="email"]');
      var tags = form.querySelector('[data-ban-tags]');
      var own = code(em && em.value);
      if (own) set('ban_wl_code', own);
      if (tags) {
        var list = tags.value.split(',').map(function (t) { return t.trim(); }).filter(Boolean);
        if (own) list.push('code:' + own);
        var r = ref();
        if (r && r !== own) list.push('ref:' + r);
        tags.value = list.filter(function (t, i, a) { return a.indexOf(t) === i; }).join(', ');
      }
      set('ban_wl_pending', form.id || '1');
    });
  }

  function link(c) { return w.location.origin + '/pages/waitlist?ref=' + (c || get('ban_wl_code') || ''); }

  function legacyCopy(text) {
    var ta = d.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', '');
    ta.style.position = 'fixed'; ta.style.opacity = '0';
    d.body.appendChild(ta); ta.select();
    try { d.execCommand('copy'); } catch (e) {}
    d.body.removeChild(ta);
  }
  function copy(text, btn, doneLabel) {
    var ok = function () {
      if (!btn) return;
      var o = btn.textContent;
      btn.textContent = doneLabel || 'Copied';
      btn.classList.add('is-copied');
      setTimeout(function () { btn.textContent = o; btn.classList.remove('is-copied'); }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(ok, function () { legacyCopy(text); ok(); });
    } else { legacyCopy(text); ok(); }
  }

  w.BanWL = { get: get, set: set, del: del, code: code, ref: ref, attach: attach, link: link, copy: copy,
    posted: params.get('customer_posted') === 'true' };

  Array.prototype.forEach.call(d.querySelectorAll('form[data-ban-wl]'), attach);
})(window, document);
